module.exports = __webpack_public_path__ + "static/media/telegram.c72f3318.svg";